
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import AdminOverview from '@/components/administration/AdminOverview.vue';
import AdminClients from '@/components/administration/AdminClients.vue';
import AdminAlertingMeters from '@/components/administration/AdminAlertingMeters.vue';
import AdminImportLogs from '@/components/administration/AdminImportLogs.vue';
import AdminDataFlow from '@/components/administration/AdminDataFlow.vue';
import AdminRestartImport from '@/components/administration/AdminRestartImport.vue';
import DataloggerFirmwares from '@/components/datalogger/DataloggerFirmwares.vue';

const TABS = [
  {key: 'accueil', label: 'Accueil'},
  {key: 'clients', label: 'Clients'},
  {key: 'alertes', label: 'Compteurs en alerte'},
  {key: 'imports', label: 'Imports'},
  {key: 'flux', label: 'Flux'},
  {key: 'relance', label: 'Relancer un import'},
  {key: 'firmwares', label: 'Firmwares'},
];

/**
 * Administration globale de la plateforme (admins). Onglet actif dans l'URL : /administration/:tab
 * (sans onglet : accueil). Remplace les anciennes pages /listClient et /listLogs (redirigées).
 */
@Component({components: {AdminOverview, AdminClients, AdminAlertingMeters, AdminImportLogs, AdminDataFlow, AdminRestartImport, DataloggerFirmwares}})
export default class Administration extends Vue {
  @Prop({default: null})
  tab: string;

  tabs = TABS;

  mounted(): void {
    this.$store.commit('setBreadCrumbName', '');
  }

  get activeTab(): string {
    return this.tab || 'accueil';
  }

  set activeTab(tab: string) {
    this.selectTab(tab);
  }

  tabRoute(tab: string): { name: string; params: Record<string, string> } {
    return {name: 'administration', params: tab === 'accueil' ? {} : {tab}};
  }

  /** Lien d'onglet : l'onglet actif garde les paramètres de l'URL (filtres du Flux…), sinon « exact » ne le reconnaît plus */
  linkRoute(tab: string): { name: string; params: Record<string, string>; query?: Record<string, unknown> } {
    return tab === this.activeTab ? {...this.tabRoute(tab), query: this.$route.query} : this.tabRoute(tab);
  }

  selectTab(tab: string): void {
    if (tab !== this.activeTab) {
      this.$router.replace(this.tabRoute(tab)).catch(() => undefined);
    }
  }

  /** Onglet inconnu → accueil */
  @Watch('tab', {immediate: true})
  checkTab(): void {
    if (this.tab && !TABS.some((t) => t.key === this.tab)) {
      this.selectTab('accueil');
    }
  }
}
